import { useState } from "react";
import { NavLink } from "react-router-dom";
import { retryCallbackCsv } from "../../config/LiveApi";

function RetryCallback() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null); // reset old result
  };

  const uploadCSV = async () => {
    if (!file) {
      return alert("Please select a CSV file");
    }

    try {
      setLoading(true);

      const res = await retryCallbackCsv(file);

      setResult(res?.data);
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <nav className="navbar-accounts">
        <div className="nav-links-accounts">
          <NavLink to="/payout-pending-summary">
            Fetch Data and Download
          </NavLink>
          <NavLink to="/payout-pending-data">Get Data</NavLink>
          <NavLink to="/failed-pending-payout">
            Failed Txn
          </NavLink>
          <NavLink
            to="/retry-callback"
            className="active-accounts"
          >
            Retry Callback
          </NavLink>
        </div>
      </nav>

      <h2>Upload CSV to Retry Callback</h2>

      <div
        style={{
          marginTop: "20px",
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          width: "400px",
        }}
      >
        <input
          type="file"
          accept=".csv"
          onChange={handleFileChange}
        />

        <br />
        <br />

        <button
          onClick={uploadCSV}
          disabled={loading}
          style={{
            padding: "8px 20px",
            background: "#fc8019",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          {loading ? "Processing..." : "Upload CSV"}
        </button>
      </div>

      {/* Result Display */}
      {result && (
        <div
          style={{
            marginTop: "30px",
            padding: "20px",
            background: "#fafafa",
            borderRadius: "8px",
            width: "500px",
          }}
        >
          <h3>Processing Result</h3>

          <p>
            Total Records: <strong>{result.totalRecords}</strong>
          </p>
          <p>
            Successfully Retried: <strong>{result.processed}</strong>
          </p>
          <p>
            Failed: <strong>{result.failed}</strong>
          </p>

          {result.failedIds?.length > 0 && (
            <>
              <p>Failed IDs:</p>
              <ul style={{ maxHeight: "150px", overflowY: "auto" }}>
                {result.failedIds.map((id, index) => (
                  <li key={index}>{id}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default RetryCallback;